<template>
  <div
    class="criteria-radio-card main__light_green rounded-lg px-6 pb-6 pt-7"
    :class="type"
    data-qa="criteria-radio-card"
    elevation="0">
    <sButton
      class="exit-btn"
      data-qa="exit-btn"
      icon="cross"
      icon-size="16px"
      small
      type="text"
      @click="close"/>
    <sFormItem
      v-if="type === 'criterionKind'"
      data-qa="criterion-type-form-item"
      :label="$t('Tenders.CriterionType')"
      :prop="type">
      <sSelect
        class="criteria-radio-card__criterion-select width-100"
        data-qa="criterion-select"
        :placeholder="$t('Common.Select')"
        :value.sync="value"
        @change="val => $emit('change', val)">
        <sOption
          v-for="option in filteredOptions"
          :key="option.value"
          :label="option.label"
          :value="option.value">
          {{ option.label }}
        </sOption>
      </sSelect>
    </sFormItem>
    <RadioGroup
      v-else
      class="criteria-radio-card__radio-group"
      data-qa="radio-group"
      :header="header"
      header_class="mb-3"
      :items="options"
      label_class="h7-text"
      :model.sync="value"
      @change="val => $emit('change', val)"/>
    <RadioGroup
      v-if="!not_for_all && type"
      class="mt-3 criteria-radio-card__apply-all-items-radio"
      data-qa="apply-all-items"
      :header="$t(`Tenders.ApplyAllCriterias`)"
      label_class="h7-text"
      :model.sync="all_mode"
      row/>
    <slot
      name="additional"
      :value="value"/>
    <div class="mt-2 flex flex-right">
      <sButton
        data-qa="criteria-radio-card__submit-btn"
        :disabled="disabled"
        small
        @click="apply">
        {{ $t('Common.Apply') }}
      </sButton>
    </div>
  </div>
</template>
<script>
import RadioGroup from 'components/common/inputs/RadioGroup.vue'

import { criteriasMixin } from 'mixins'

export default {
  name: 'criteriaRadioCard',
  mixins: [ criteriasMixin],
  data() {
    return {
      all_mode: false,
      value: ''
    }
  },
  props: {
    chechDisabled: {
      type: Function,
      default: () => {}
    },
    model: [String, Boolean],
    type: String,
    header: String,
    options: Array,
    close: Function,
    submit: {
      type: Function,
      default: () => {}
    },
    not_for_all: Boolean,
    items: Array,
    card: Object,
    /**
     * збереження карти в localStorage
     */
    saveCard: {
      type: Function,
      default: () => {}
    },
    item: Object
  },
  created() {
    this.value = this.model ?? (!this.options || this.options[0].value)
  },
  computed: {
    filteredOptions() {
      if (this.type === 'criterionKind') {
        return this.options.filter(el => el.value !== 'ANALOG' || this.item.criterionControlType !== 'CALCULATED')
      }
      return this.options
    },
    disabled() {
      return this.chechDisabled(this.value)
    }
  },
  methods: {
    apply() {

      if ( this.all_mode ) {
        this.items.forEach(el => {
          this.submit(el, this.value)
        })

      } else {
        this.$emit('update:model',  this.value)
        this.submit( null , this.value )
      }
      this.saveCard()
    }
  },
  components: {
    RadioGroup
  }
}
</script>
<style lang="scss" scoped>
.criteria-radio-card {
  position: relative;
  z-index: 100;
  .exit-btn {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}
</style>
